import React from "react";
import ApiResponse from "sr/models/ApiResponse";
import { remove } from "sr/utils/axios";

export const deleteClearerData = async (payload) => {
    try {
  return await remove<ApiResponse<[]>>(`/cleaner/clear`, payload).then((res)=>{
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){

}
};
